/**
 * A GL pull is already running for the table+period (HTTP 409, backend
 * {@code PullAlreadyInProgressException}). Distinct from {@link EntityLockedError}: this is a
 * concurrent-operation conflict, not an edit lock, and it carries the in-flight pull's
 * {@code pullRequestId} so the caller can attach to and resume polling it rather than showing a
 * generic failure. The two 409 bodies are disjoint (a lock 409 carries lockedBy/lockedAt and no
 * pullRequestId), so the shared response handler can tell them apart by shape.
 */
export class PullInProgressError extends Error {
    public status: number;
    public pullRequestId: string;

    constructor(message: string, pullRequestId: string) {
        super(message);
        this.name = 'PullInProgressError';
        this.status = 409;
        this.pullRequestId = pullRequestId;
        Object.setPrototypeOf(this, PullInProgressError.prototype);
    }
}
